import React from "react";
import { ButtonIcon } from "@loanbossinc/component-library";
import styled from "styled-components";

const Wrapper = styled.div`
    width: 278px;
    height: 48px;
    font-family: Work Sans;
    font-size: 16px;
    font-weight: 500;
    line-height: 19px;
    color: #000000;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #DADCE0;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-items: center;
`;

const CalendarButton = props => (
  <Wrapper {...props}>
    <div>
      {props.label}
      {" "}
      {props.value}
    </div>
    <ButtonIcon iconName="date_range" hasBorder={false} style={{ color: "#005AA9" }} />
  </Wrapper>
);

export default CalendarButton;
